import React from 'react'
import { Link } from 'react-router-dom';
import Loading from '../components/Loading';
import useFetch from '../hooks/useFetch';

const About = () => {
  const [data, loading] = useFetch('/users/index');
  return (
    <>
    {loading ? <Loading /> :
      <div className='about-container'>
        <div className='about-image'>
          <img src={data.prime_image} alt='profile.png'/>
        </div>
        <div className='about-content'>
          <h4>About Me</h4>
          <p className='about-content-text text-white' dangerouslySetInnerHTML={{__html: data.about_me}}></p>
          <Link to="/" className='about-btn'>Hire Me</Link>
          <Link to="/" className='about-btn'>Download CV</Link>
        </div>
      </div>
      }
    </>
  )
}

export default About